(() => {
    const mywuData = sessionStorage.getItem('state');
    let parseMywuData = null;
    try {
        parseMywuData = mywuData ? JSON.parse(mywuData) : null;
    } catch (e) {
        parseMywuData = null;
    }    
    if (!parseMywuData?.digitalCustomerProfile?.accountNumber) {
        const { accountNumber, loyaltyFlag, registrationStatus } = wuSessionApp();

        if (accountNumber) {
            parseMywuData = {
                digitalCustomerProfile: {
                    accountNumber,
                    termsConditions: loyaltyFlag,
                    registrationStatus
                }
            };
        }
    }
    const wuRewards = document.getElementById('wu_rewards');
    const registerDeals = wuRewards?.querySelector('.register-deals');
    const loginDeals = wuRewards?.querySelector('.login-deals');
    const loyaltyVerifiedUser = wuRewards?.querySelector('.loyalty-verified-user');
    const loyaltyUnverifiedUser = wuRewards?.querySelector('.loyalty-unverified-user');
    const loyaltyUnverifiedFullRegUser = wuRewards?.querySelector('.loyalty-unverified-full-reg-user');

    const wuOfferDeals = document.getElementById('wu_offer_deals');
    const registerViewDeals = wuOfferDeals?.querySelector('.register-view-deals');
    const verifiedViewDeals = wuOfferDeals?.querySelector('.verified-view-deals');
    const unverifiedViewDeals = wuOfferDeals?.querySelector('.unverified-view-deals');
    const registerViewDealsFullRegUser = wuOfferDeals?.querySelector('.unverified-view-deals-full-reg-user');
    const lockDeals = wuOfferDeals?.querySelector('.lock-deals');

    const pageData = window.pageData;
    const location = window.location;

    const E1_COUNTRIES = JSON.parse(pageData?.E1_COUNTRIES || '[]');
    const isE1Country = E1_COUNTRIES
        .map(c => c.toUpperCase())
        .includes(pageData?.country?.toUpperCase());

    if (parseMywuData && parseMywuData?.digitalCustomerProfile?.accountNumber !== undefined) {
        toggleClass(registerDeals, 'd-block', 'd-none');
        toggleClass(loginDeals, 'd-block', 'd-none');
        toggleClass(registerViewDeals, 'd-block', 'd-none');
        if (!isE1Country){
            toggleClass(registerViewDeals, 'd-none', 'd-block'); 
            toggleClass(lockDeals, 'd-flex', 'd-none');
        }
        if (isE1Country) {
        if(parseMywuData?.digitalCustomerProfile?.termsConditions === true) {
            toggleClass(loyaltyVerifiedUser, 'd-none', 'd-block');
            toggleClass(verifiedViewDeals, 'd-none', 'd-block');
            toggleClass(lockDeals, 'd-flex', 'd-none');
        } else if(parseMywuData?.digitalCustomerProfile?.termsConditions === false) {
            if(parseMywuData?.digitalCustomerProfile?.registrationStatus === 'F') {
                toggleClass(loyaltyUnverifiedFullRegUser, 'd-none', 'd-block');
                toggleClass(registerViewDealsFullRegUser, 'd-none', 'd-block');
            } else {
                toggleClass(loyaltyUnverifiedUser, 'd-none', 'd-block');
                toggleClass(unverifiedViewDeals, 'd-none', 'd-block');
            }
        }
    }
    } else {
        toggleClass(registerDeals, 'd-none', 'd-block');
        toggleClass(loginDeals, 'd-none', 'd-block');
        toggleClass(registerViewDeals, 'd-none', 'd-block');    
        toggleClass(lockDeals, 'd-none', 'd-flex');
    }

    async function fetchLazyLoadData() {
        const observer = new IntersectionObserver(async (entries) => {
            if (entries && entries[0].isIntersecting) {
                try {
                    observer.unobserve(wuOfferDeals); //For preventing repeated calls
                    const queryParam = `_with=advertiser,badge&page=1&per_page=50`;
                    const allDealsData = await dealsCmsAPI(pageData.country, pageData.language, queryParam, 'deal');
                    const currentDate = new Date();
                    const validDeals = (allDealsData?.dealsData || [])?.filter(deal => {
                        const dealEndDate = new Date(deal?.end_date);
                        if(!deal?.end_date) return true;
                        return dealEndDate >= currentDate;
                    });

                    const topDeals = validDeals?.slice(0, 4);
                    renderDeals(topDeals);
                } catch (error) {
                    console.log('Error occurred while fetching or filtering WU rewards deals');
                }
            }
        });
        wuOfferDeals && observer.observe(wuOfferDeals);
    }

    wuOfferDeals && fetchLazyLoadData();

    function renderDeals(dealList) {
        const dealsEL = document.getElementById("dealsListLoyalty");
        let dealHtmlContent = '';

        dealList.forEach((item) => {
            const slug = item?.badge?.[0]?.slug || '';
            let dealHeaderBackground = 'bk-black';
            let badgeTextColor = 'text-yellow';
            let iconClass = 'icon-J21-List-Bill';
            
            if (slug.includes('deal-of-the-week')) {
                dealHeaderBackground = 'bk-black';
                badgeTextColor = 'text-yellow';
                iconClass = 'icon-J21-List-Bill';
            } else if (slug.includes('ending-soon')) {
                dealHeaderBackground = 'bk-red-tint-02';
                badgeTextColor = 'text-alert-dark';
                iconClass = 'icon-G05-Clock-Fast-Payment';
            } else if (slug.includes('trending')) {
                dealHeaderBackground = 'bk-green-tint-02';
                badgeTextColor = 'text-success-dark';
                iconClass = 'icon-C02-Speaker-Announce-Marketing-Promotion-Ads';
            }
            
            const opac = slug ? 'opac-1' : 'opac-0';
            const isLoggedIn = parseMywuData?.digitalCustomerProfile?.accountNumber !== undefined;

            const shouldRedirectToRewardsHome =
                !isE1Country &&
                isLoggedIn &&
                (
                    parseMywuData?.digitalCustomerProfile?.termsConditions !== '1' ||
                    parseMywuData?.digitalCustomerProfile?.registrationStatus !== 'F'
                );
            const dealUrl = isE1Country
                ? (isLoggedIn ? `${location.protocol}//${location.hostname}/${pageData.country}/${pageData.language}/web/rewards/deals?dealId=${item.id}` : `${location.protocol}//${location.hostname}/${pageData.country}/${pageData.language}/web/user/register?redirectURL=rewards/deals?dealId=${item.id}`)
                : (isLoggedIn ? shouldRedirectToRewardsHome ? `${location.protocol}//${location.hostname}/${pageData.country}/${pageData.language}/rewards/home.html` : `${location.protocol}//${location.hostname}/${pageData.country}/${pageData.language}/rewards/shop-deals.html?dealId=${item.id}` : `${location.protocol}//${location.hostname}/${pageData.country}/${pageData.language}/web/user/register?Route=MYWUSITEREGISTER&RouteType=REDIRECT&requestFrom=mywu?dealId=${item.id}`);

            dealHtmlContent += '<div class="col col-8 col-L-4 col-M-8 d-flex">';
                dealHtmlContent += '<a href="'+ dealUrl +'"  id="dealSpecific" class="text-decoration-none d-block w-100" style="color: inherit;" amplitude-id="button-tile-'+ (item?.advertiser?.name || '') + '_' + (item?.name || '') + '_' + (item?.description || '') + (item.badge?.[0]?.name ? '_' + item?.badge[0].name : '') + '" mparticle-event-name="clicked_button" data-deal-id="'+item?.id+'">';
                dealHtmlContent += '<div class="wu-card wu-card--primary mar-xs-bm w-100 cursor-pointer d-flex flex-column" >';
                    dealHtmlContent += '<div class="deal-header bdr-radius-tp pad-8-vert pad-xxxxs-horz ' + dealHeaderBackground + ' ' + opac + '">';
                        dealHtmlContent += '<span class="' + badgeTextColor + ' pad-xxxs-lt">';
                            dealHtmlContent += '<span role="presentation" class="' + iconClass + ' wu-icon__sm pad-8-rt"></span>' + item?.badge[0]?.name;
                        dealHtmlContent += '</span>';
                    dealHtmlContent += '</div>';
                    dealHtmlContent += '<div class="text-center pad-xxl-horz pad-8-vert bk-white" style="mask:radial-gradient(20px at 40px 100%,#0000 98%,#000) -40px"><img class="pad-M-xxxs-all w-100" data-lazyload-mobile-desktop-src="'+ item?.deal_image + '" alt="' + item?.name + '" style="height:94px;object-fit:contain" src="'+ item?.deal_image + '"></div>';
                    dealHtmlContent += '<div class="bdr-thin-tp-dotted bdr-color-grey-02 w-100 pad-8-vert bk-white" style="mask: radial-gradient(20px at 40px 0,#0000 98%,#000) -40px"> </div>';
                    dealHtmlContent += '<div class="deal-content pad-xxs-horz pad-xxxs-bm bk-white bdr-radius-bm d-flex flex-column flex-grow-1" style="min-height:106px;">';
                        dealHtmlContent += '<p class="font-body-01 font-weight-500 text-truncate text-nowrap overflow-hidden text-grey-05" style="text-overflow: ellipsis;">  ' + item?.advertiser?.name + '</p>';
                        dealHtmlContent += '<p class="font-label-01 font-weight-500  pad-8-tp text-truncate text-nowrap overflow-hidden text-black" style="text-overflow: ellipsis;">' + item?.name + '</p>';
                        dealHtmlContent += '<p class="font-body-02 font-weight-400 pad-4-tp text-grey-05" style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">' + item?.description + '</p>';
                    dealHtmlContent += '</div>';
                dealHtmlContent += '</div>';
                dealHtmlContent += '</a>';
            dealHtmlContent += '</div>';
        });

        dealsEL.insertAdjacentHTML("beforeEnd", dealHtmlContent);       
    }
})()